import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"

import Box from "../atoms/Box"
import Modal from "../atoms/Modal"
import Html from "../atoms/CustomHtml"
import SectionTitle from "../molecules/SectionTitle"
import Popup from "../atoms/Popup"

const CustomHtmlPopup = ({
  id,
  strapi_id,
  modal,
  modalProps,
  alignHtml,
  integration,
  customHtmlWidth,
  popup,
}) => {
  let image = "/popup-integrations.jpg"
  const integrationData = integration?.dataObj || integration?.data

  const integrationRendered = !integration ? (
    <img
      alt="integration placeholder image"
      src={image}
      style={{ position: "static" }}
    />
  ) : (
    integration?.type === "customHtml" &&
    integrationData?.html && (
      <Html
        display="flex"
        flexDirection="column"
        alignItems={alignHtml === "center" ? "center" : "stretch"}
        html={integrationData.html}
        height="100%"
        width="100%"
        maxWidth={customHtmlWidth > 0 ? customHtmlWidth : "100%"}
        overflow="hidden"
        minHeight="500px"
      />
    )
  )

  return (
    <Popup
      id={id || strapi_id}
      modal={modal}
      modalProps={modalProps}
      {...popup}
      // background="white"
    >
      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems={customHtmlWidth > 0 ? "center" : "stretch"}
        overflow="hidden"
        width="100%"
        height="100%"
      >
        {integrationRendered}
      </Box>
    </Popup>
  )
}

CustomHtmlPopup.propTypes = {
  strapi_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  popup: PropTypes.shape(Popup.strapiProps).isRequired,
  modal: PropTypes.shape(Modal.strapiProps).isRequired,
  sectionTitle: PropTypes.shape(SectionTitle.strapiProps),
  integration: PropTypes.shape({
    type: PropTypes.oneOf(["customHtml"]),
    data: PropTypes.object,
  }),
}

export default CustomHtmlPopup

export const query = graphql`
  fragment CustomHtmlPopup on STRAPI__COMPONENT_POPUPS_CUSTOM_HTML {
    strapi_id
    popup {
      ...Popup
    }
    modal {
      ...Modal
    }
    integration {
      type
      dataObj: data
    }
    alignHtml
    customHtmlWidth
  }
`
